<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" class="ion-padding">
      <ion-grid fixed>
        <Header
          class="u-bg-grey -contain-bottom"
          headline="Der kompetente ARAG-Partner für den digitalen Artzbesuch."
          :image="require('@/assets/img/header/icon_medgate.svg')"
          @openChat="openChat('contactMedgate')"
        />
        <p>
          <b>Arztgespräch – schnell und bequem per Video oder Telefon</b>
        </p>
        <p>
          An 365 Tagen im Jahr stehen in bestimmten Fällen* erfahrene Ärzte rund
          um die Uhr per Video für eine Abklärung Ihrer Gesundheitsfragen für
          Sie bereit.
        </p>
        <!-- <p>
          An 365 Tagen im Jahr stehen erfahrene Ärzte rund um die Uhr per Video
          für eine erste Abklärung Ihrer Gesundheitsfragen für Sie bereit.
        </p> -->
        <!-- <p>
          Ein digitales Arztgespräch kann den persönlichen Arztbesuch vor Ort
          zwar nicht ersetzen, aber ergänzen.
        </p> -->

        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="require('@lib/assets/icons/icon_verlaufskontrolle.svg')"
              />
            </ion-col>
            <ion-col>
              &nbsp;<b>1.</b> Sie werden direkt zur Medgate-App weitergeleitet,
              um sich mit Auswahl der ARAG Krankenversicherung und Angabe Ihrer
              Versicherungsnummer zu registrieren und anzumelden.
            </ion-col>
          </ion-row>
        </p>
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="require('@lib/assets/icons/icon_telefon.svg')"
              />
            </ion-col>
            <ion-col>
              &nbsp;<b>2.</b> Buchen Sie direkt in der App einen Termin für das
              digitale Arztgespräch. Ein Medgate Arzt kontaktiert Sie zum
              vereinbarten Termin.
            </ion-col>
          </ion-row>
        </p>
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="require('@lib/assets/icons/icon_erstdiagnose.svg')"
              />
            </ion-col>
            <ion-col>
              &nbsp;<b>3.</b> Am Ende erhalten Sie einen Behandlungsplan und bei
              Bedarf eine Überweisung, ein Rezept oder eine
              Arbeitsunfähigkeitsbescheinigung.
            </ion-col>
          </ion-row>
        </p>
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="require('@lib/assets/icons/money.svg')"
              />
            </ion-col>
            <ion-col>
              &nbsp;<b>4.</b> ARAG erstattet die Arztrechnungen im tariflichen
              Rahmen – natürlich auch, wenn Sie einen anderen Serviceanbieter
              wählen.
            </ion-col>
          </ion-row>
        </p>

        <div class="c-cta">
          <ion-button @click="openVideoMedgateModal()" class="mt-5"
            >Für digitalen Arztbesuch anmelden&nbsp;
            <ion-icon
              :src="require('@lib/assets/icons/roodie-white.svg')"
              slot="end"
            ></ion-icon>
          </ion-button>
        </div>

        <div class="ion-margin-top">
          <ion-icon :src="require('@lib/assets/icons/info.svg')" />
          <ion-text color="primary"
            >&nbsp;<b>Hinweis:</b>
            <p>
              * Ein digitaler Arztbesuch ist möglich, wenn nach allgemein
              anerkannten fachlichen Standards ein persönlicher ärztlicher
              Kontakt nicht erforderlich ist.
            </p>
            <!-- <p>
            Eine Fernbehandlung kann einen persönlichen Arztbesuch nicht
            ersetzen, ist aber eine gute Ergänzung. Ob eine Behandlung ohne
            persönlichen Kontakt erfolgen kann, legt ein Medgate-Arzt im Vorfeld
            fest.
          </p> -->
          </ion-text>
        </div>

        <ion-row class="ion-margin-top">
          <ion-col>
            <div
              class="c-nugget u-bg-grey"
              @click="
                $router.push({
                  name: 'medgate',
                  params: { from: 'contact' },
                })
              "
            >
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' + require('@/assets/img/slider/medgate.svg') + ')',
                }"
              ></div>
              <div class="c-nugget__label">
                Über Medgate
              </div>
            </div>
          </ion-col>
          <ion-col>
            <div class="c-nugget u-bg-grey" @click="openKostenerstattungModal">
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/icon_roodie_call.svg') +
                    ')',
                }"
              ></div>
              <div class="c-nugget__label">
                Kostenerstattung ARAG
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { chevronBack, call, videocam, helpCircle } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonIcon,
  IonButtons,
  IonGrid,
  IonRow,
  IonCol,
  // IonList,
  // IonItem,
  // IonCheckbox,
  // IonLabel,
  IonText,
  IonBackButton,
  // IonModal,
  modalController,
} from "@ionic/vue";
// import Privacy from "@/components/Privacy";
import KostenerstattungModal from "@arag/components/KostenerstattungModal";
import PhoneMedgateModal from "@arag/components/PhoneMedgateModal";
import VideoMedgateModal from "@arag/components/VideoMedgateModal";
// import Roodie from "@lib/components/svg/Roodie";
// import ModalClose from "@lib/components/ModalClose";
import Header from "@/components/Header";
import { chat } from "@/mixins/chat";

export default {
  mixins: [chat],
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonIcon,
    IonButtons,
    IonGrid,
    IonRow,
    IonCol,
    IonBackButton,
    // IonModal,
    // IonList,
    // IonItem,
    // IonCheckbox,
    // IonLabel,
    // Roodie,
    // ModalClose,
    Header,
    IonText,
    // Privacy,
  },
  data() {
    return {
      isMedgateDatenschutzModalOpen: false,
    };
  },
  methods: {
    async openKostenerstattungModal() {
      const modal = await modalController.create({
        component: KostenerstattungModal,
      });
      return modal.present();
    },
    async openPhoneMedgateModal() {
      const modal = await modalController.create({
        component: PhoneMedgateModal,
        cssClass: "c-autoheight-modal",
      });
      return modal.present();
    },
    async openVideoMedgateModal() {
      const modal = await modalController.create({
        component: VideoMedgateModal,
        cssClass: "c-autoheight-modal",
      });
      return modal.present();
    },
  },
  setup() {
    return {
      chevronBack,
      call,
      videocam,
      helpCircle,
    };
  },
};
</script>

<style lang="scss" scoped></style>
